import AppForm from '../app-components/Form/AppForm';

Vue.component('company-contract-type-form', {
    mixins: [AppForm],
    data: function() {
        return {
            form: {
                name: null,
                shortcode: null,
                company_id: null,
            }
        }
    },

    methods: {
        goBack()
        {
            window.location.href = '/company-contracts-types';
        }
    }
});



// WEBPACK FOOTER //
// ./resources/assets/admin/js/company-contract-type/Form.js